@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-brands/glass-house-quantity-and-price/glass-house-quantity-and-price.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
:host .glass-house-2-columns {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
}
:host .glass-house-2-columns > * {
  flex: 1;
}
:host .glass-house-quantity-and-price {
  padding: 0.25rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  justify-content: flex-start;
  align-items: center;
}
:host .glass-house-quantity-and-price .glass-house-line-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
:host .glass-house-quantity-and-price .glass-house-line-item .glass-house-quantity-and-badges {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: flex-start;
  align-items: center;
  max-width: 50%;
}
:host .glass-house-quantity-and-price .glass-house-line-item .glass-house-quantity-and-badges .glass-house-quantity {
  font-family: onest, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  text-align: center;
  line-height: 100%;
  letter-spacing: 1.92px;
}
:host .glass-house-quantity-and-price .glass-house-line-item .glass-house-quantity-and-badges .glass-house-product-tags {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  max-height: 1rem;
  overflow: clip;
}
:host .glass-house-quantity-and-price .glass-house-line-item .glass-house-quantity-and-badges .glass-house-product-tags .glass-house-product-tag {
  font-family: onest, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.4375rem;
  line-height: 100%;
  background-color: #222222;
  text-transform: uppercase;
  border-radius: 0.125rem;
  color: #ffffff;
  padding: 0.25rem 0.35rem;
  white-space: nowrap;
}
:host .glass-house-quantity-and-price .glass-house-line-item .glass-house-price {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-family: onest, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  line-height: 100%;
  letter-spacing: 1.92px;
  height: 2rem;
}
:host .glass-house-quantity-and-price .glass-house-n-more {
  font-family: onest, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  text-align: center;
  line-height: 100%;
  letter-spacing: 1.92px;
}
/*# sourceMappingURL=glass-house-quantity-and-price.component.css.map */
